import * as bootstrap from 'bootstrap';
import api from './ajax.js';

document.addEventListener('DOMContentLoaded', () => {
	const messageModal = document.getElementById('messageModal');
	const textArea = document.getElementById('textMessageBody');

	if (!messageModal) {
		return;
	}

	// Listen for Bootstrap's modal shown event
	messageModal.addEventListener('shown.bs.modal', (event) => {
		const trigger = event.relatedTarget; // the element that triggered the modal
		const jobId = trigger.dataset.spJob;
		const jobName = trigger.dataset.spJobName;

		// Get the modal title element
		const titleEl = messageModal.querySelector('.modal__title');

		// Remove an existing paragraph if it exists to prevent duplicates
		const nextEl = titleEl.nextElementSibling;
		if (nextEl && nextEl.tagName.toLowerCase() === 'p') {
			nextEl.remove();
		}

		// Create a new paragraph element
		const messagePara = document.createElement('p');
		messagePara.textContent = `Send a message to the team working on ${jobName}`;

		// Add a class to the paragraph
		messagePara.classList.add('text-center');

		// Add style to the paragraph
		messagePara.style.marginLeft = 'auto';
		messagePara.style.marginRight = 'auto';
		messagePara.style.maxWidth = '380px';

		// Insert the paragraph right after the title
		titleEl.insertAdjacentElement('afterend', messagePara);

		// Save the jobId on the modal element for later use
		messageModal.dataset.jobId = jobId;

		// Remove any previous alert message when reopening the modal
		const existingAlert = messageModal.querySelector('.alert');
		if (existingAlert) existingAlert.remove();
	});

	// Clear the textarea on modal close
	messageModal.addEventListener('hidden.bs.modal', () => {
		textArea.value = '';
	});

	// Bind a click event to the Send button
	const sendMessageButton = document.getElementById('sendMessage');
	sendMessageButton.addEventListener('click', () => {
		// Show the spinner icon
		const spinner = sendMessageButton.querySelector('svg');
		if (spinner) spinner.style.display = 'inline-block';

		// Remove any existing alert message
		const existingAlert = messageModal.querySelector('.alert');
		if (existingAlert) existingAlert.remove();

		const jobId = messageModal.dataset.jobId;
		const messageEl = document.getElementById('textMessageBodyJob');
		const message = messageEl.value;

		if (!jobId) {
			console.error('Job ID not found.');
			if (spinner) spinner.style.display = 'none';
			return;
		}

		api.sendMessage(jobId, message)
			.then(response => {
				if (response.error) {
					// Show alert in modal if an error occurred
					const alertDiv = document.createElement('div');
					alertDiv.className = 'alert alert-danger';
					alertDiv.textContent = 'An error occurred while trying to send message';
					// Insert alert at the top of the modal body
					const modalBody = messageModal.querySelector('.modal__body');
					modalBody.insertBefore(alertDiv, modalBody.firstChild);
				} else {
					// If successful, hide spinner and close the modal
					if (spinner) spinner.style.display = 'none';
					const modalInstance = bootstrap.Modal.getInstance(messageModal);
					if (modalInstance) modalInstance.hide();
				}
			})
			.catch(error => {
				console.error('Error sending message:', error);
				const alertDiv = document.createElement('div');
				alertDiv.className = 'alert alert-danger';
				alertDiv.textContent = 'An error occurred while trying to send message';
				const modalBody = messageModal.querySelector('.modal__body');
				modalBody.insertBefore(alertDiv, modalBody.firstChild);
			})
			.finally(() => {
				if (spinner) spinner.style.display = 'none';
			});
	});
});
